// extracted by mini-css-extract-plugin
module.exports = {"modalDesign":"recuiterTabModal_modalDesign__1ERnE","modalView":"recuiterTabModal_modalView__3WqGK"};